import axios from 'axios';
export default {
    state: {
        earningsList:{},
    },
    getters: {
    },
    mutations: {
        getEarnings(state, earningsList){ 
            state.earningsList = earningsList;
        },
    },
    actions: {
        getIndividualIncome({commit},{url}){
            axios.get(url).then(res=>{
                commit("getEarnings",res.data); 
            })
        },
      
    }
}